module.exports = __webpack_public_path__ + "media/assets/icons/mobile2-87e76f5f7fe4c93562edfb18a4564e74.svg";